import { SECTION_EACH, SECTION_IF, SECTION_IF_WITH, SECTION_UNLESS } from '../../../config/types';

export default {
	each:    SECTION_EACH,
	if:      SECTION_IF,
	with:    SECTION_IF_WITH,
	unless:  SECTION_UNLESS
};

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/parse/converters/mustache/handlebarsBlockCodes.js.map
